module.exports = __webpack_public_path__ + "img/section16.ada69b6d.png";